import { ObservableFromFetch } from "../../ObservableFromFetch"
import { Filter, Sort } from "../../GridRequest"
import PortalGridData from "./PortalGridData"

export function PortalGridGetObservable(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }, implementationGroupID?: number) {
  const requestBody: string = JSON.stringify({
    ImplementationGroupID: implementationGroupID,
    PageNumber: pageNumber,
    PageSize: pageSize,
    SearchBy: search.field || "",
    SearchText: search.text || "",
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order.toUpperCase() }
  })

  return ObservableFromFetch<PortalGridData>("WorkforceSuperUser/PortalDetails", requestBody)
}
